import { T, Var } from 'gt-react';
import config from 'src/config';

export function CopyrightOverlay() {
  return (
    <div className="fixed bottom-2 right-2 z-50 pointer-events-none select-none">
      <CopyrightText />
    </div>
  );
}

/**
 * In-flow variant for pages that pin their own bottom bar (e.g. the inbox
 * approval pane): rendered at the end of the scrollable content instead of
 * floating over the sticky footer.
 */
export function CopyrightLine() {
  return (
    <div className="select-none pt-2 text-right">
      <CopyrightText />
    </div>
  );
}

function CopyrightText() {
  const year = new Date().getFullYear();
  return (
    <span className="text-xs text-muted-foreground/50 font-light">
      <T context="copyright footer notice with support email">
        Gently © <Var>{year}</Var> <Var>{config.supportEmail}</Var>
      </T>
    </span>
  );
}
